import React, { useState, useContext } from "react";
import Alert from "@mui/material/Alert";
import "./VerifyEmail.scss";
import AtomicButton from "../../atomic/button/AtomicButton";
import OtpVerify from "../../atomic/otpverify/OtpVerify";
import { SignUpInfoDataContext } from "../../context-api/SignUpInfoDataProvider";
import variables from "../../global/assets/_variables.scss";
import { isMobile } from "../../global/ScreenSizeHelper";
import { useNavigate } from "react-router";

function VerifyEmail({
  resendEmailOTPHandler,
  verifyEmailOTPHandler,
  redirectToThankYouPage = false,
  verifyOtpAPIResponse,
  generateOtpAPIResponse

}) {
  const navigate = useNavigate();
  const [otp, setOTP] = useState("");
  const singUpInfoContext = useContext(SignUpInfoDataContext);
  const { signUpPageEmail } = singUpInfoContext;
  const email = signUpPageEmail;
  const defaultOTPErrorMessage = "Invalid OTP Token";
  const otpLabel = "Verify Email address";
  const otpSent = "An OTP code has been sent to your email.";
  const otpExpiryLabel = "Your OTP code will expire in 10 minutes.";
  const resendTitle1 = "Didn't receive the code?";
  const resendTitle2 = "Resend Code";
  const submitButtonLabel = "Verify";
  const OTP_LENGTH = 5;
  const ShowOTPError = verifyOtpAPIResponse?.success === false && verifyOtpAPIResponse?.message === 'Invalid OTP Token'

  const { isLoading } = generateOtpAPIResponse
  const { isLoading: yesLoading } = verifyOtpAPIResponse



  const resendEmailOTP = async () => await resendEmailOTPHandler(email);
  const verifyEmailOTP = async () => {
    const OPTVerifyCode = await verifyEmailOTPHandler(email, otp);


    if (OPTVerifyCode?.data?.success && redirectToThankYouPage)
      navigate('/onthemenu')
    window.location.reload()
  };


  const containerClass = isMobile
    ? "verify-email-container verify-email-container-mobile"
    : "verify-email-container";
  return (
    <div className={containerClass}>
      <div className="top-label">{otpLabel}</div>
      <div className="otp-sent">{otpSent}</div>
      <div className="email">{email}</div>
      {ShowOTPError && (
        <Alert
          severity="error"
          sx={{
            border: `solid 1px ${variables.borderErrorRed}`,
            fontSize: "14px",
            color: variables.backGroundErrorRed,
            margin: "8px 0px",
            width: isMobile ? '330px' : '418px'
          }}
        >
          {verifyOtpAPIResponse?.message || defaultOTPErrorMessage}
        </Alert>
      )}
      <div className="otp-input-body">
        <div className="otp-expiry-label">{otpExpiryLabel}</div>
        <div className="otp-input-section">
          <OtpVerify digits={OTP_LENGTH} setOTP={setOTP} otp={otp} />
        </div>
        <div className="resend-email-section">
          <span className="resend-title1">{resendTitle1}</span>
          <button className="resend-title2" onClick={resendEmailOTP}>
            {resendTitle2}
          </button>
        </div>
        <AtomicButton
          label={submitButtonLabel}
          style={{ backgroundColor: "#181436" }}
          handleSubmit={verifyEmailOTP}
          disabled={isLoading || yesLoading}
          loading={isLoading || yesLoading}
        />
      </div>
      <div className="anonymous-user-content">
        I'm not <span className="email">{email}</span><br />
        take me to <span className="redirect-button">home page</span>
      </div>
    </div>
  );
}

export default VerifyEmail;
